'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import slugify from 'slugify'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'

import { useGlobalStore } from '@/store/provider'
import { pages, popularCategories } from '@/settings'
import { lookup } from '@cruz-com/lookup'
import { Divider } from '@/components'

type MenuProps = {
  name?: string
  menu?: string | React.ReactNode
  icon?: React.ReactNode
  href: string
  count?: number | undefined
  className?: string
  onClick: () => void
}


export function HeaderVehicleMenu() {
  const { user } = useGlobalStore((state) => state)

  const MyMenuItem = ({ name, menu, href, count, icon, className, onClick }: MenuProps) =>
    <Link hrefLang='en' key={href} href={href} className={twMerge('menu-item bg-white dark:bg-zinc-800', className)} onClick={onClick}>
      <span className='flex items-center gap-1.5'>
        {icon}
        {menu || name}
      </span>
      {
        (!_.isUndefined(count)) &&
        <span className='nav-count'>{count}</span>
      }
    </Link>

  return (
    <Popover as='div' className='h-full relative'>
      {({ close }) =>
        <>
          <PopoverButton className='menu-button font-semibold dark:font-normal'>
            <span>Vehicles</span>
            <ChevronDownIcon className='size-5 ml-1 -mr-1' />
          </PopoverButton>
          <PopoverPanel anchor='bottom start' transition={true} modal={false} className='menu-items !min-w-[380px]'>
            <div className='grid grid-cols-2 divide-x rounded-t'>
              <MyMenuItem
                {...pages.mySavedVehicle}
                menu='My Saved Vehicle'
                count={user?.statistic?.saved_vehicle}
                className='!py-4 rounded-tl'
                onClick={close}
              />
              <MyMenuItem
                {...pages.mySavedSearch}
                menu='My Saved Search'
                count={user?.statistic?.saved_search}
                className='!py-4 rounded-tr'
                onClick={close}
              />
            </div>
            <Divider />
            <MyMenuItem {...pages.vehicleSearch} className='!py-4 rounded-tl' onClick={close}
              menu={
                <span className='flex items-center'>
                  <MagnifyingGlassIcon className='size-5 mr-2' />
                  Search All Vehicles
                </span>
              } />
            <Divider />
            <div className='grid grid-cols-2 divide-x'>
              <div className='divide-y'>
                <div className='menu-category'>By Popular Categories</div>
                <ul role='list' className='pt-2 pb-3'>
                  {
                    _.map(popularCategories, (d, idx) =>
                      <MyMenuItem
                        key={`pc_${idx}`}
                        {...d}
                        onClick={close}
                      />)
                  }
                </ul>
              </div>
              <div className='divide-y'>
                <div className='menu-category'>By Body Styles</div>
                <ul role='list' className='pt-2 pb-3'>
                  {
                    _.map(lookup.vehicle.bodyType, (d, idx) =>
                      <MyMenuItem
                        key={`vBodyType_${idx}`}
                        href={`/vehicles/body-style-s/${slugify(d.sName)}/${d.id}`}
                        menu={<span className='truncate'>{d.sName}</span>}
                        onClick={close}
                      />
                    )
                  }
                </ul>
              </div>
            </div>
          </PopoverPanel>
        </>
      }
    </Popover>
  )
}